meedy.controller('meedy.patientListController', ['$q', '$rootScope', '$scope', '$state', '$stateParams', '$translate', '$mdDialog',
    'meedyConfig', 'meedy.authInterceptor', 'meedy.objectHelper', 'meedy.baseModel', 'meedy.applicationModel', 'meedy.userModel', 'meedy.patientModel', 'meedy.mdxOrderModel',
    function ($q, $rootScope, $scope, $state, $stateParams, $translate, $mdDialog, config, authInterceptor, objectHelper, baseModel, applicationModel, userModel,
              patientModel, mdxOrderModel) {

        var listeners = {};

        function setData() {

            $scope.Enum = Enum;
            $scope.patients = [];

            $scope.criteria = new ResourceDataGridMeedyCriteria();
            if(isMdxAuthenticated()) {
                $scope.criteria.types = [
                    Enum.MEEDY.TERM_TYPE.EXTERNAL,
                    Enum.MEEDY.TERM_TYPE.CLAIM
                ];
            } else {
                $scope.criteria.types = [Enum.MEEDY.TERM_TYPE.EXTERNAL];
            }

            $scope.criteria.sortColumns = [{columnName: "begin", descending: true}];

            $scope.columns = [
                {
                    field: "(type=='" + Enum.MEEDY.TERM_TYPE.CLAIM + "') ? 'ICR' : insurer.shortName",
                    displayName: $translate.instant('T.MEEDY.MODULE.PATIENT.INSURER'),
                },
                {
                    field: "(type=='" + Enum.MEEDY.TERM_TYPE.CLAIM + "') ? claimDetails.fullName : patientFirstName + ' ' + patientLastName",
                    displayName: $translate.instant('T.MEEDY.MODULE.PERSONAL_DATA.FIRST_NAME') + " i " + $translate.instant('T.MEEDY.MODULE.PERSONAL_DATA.LAST_NAME'),
                },
                {
                    field: "(type=='" + Enum.MEEDY.TERM_TYPE.CLAIM + "') ? claimDetails.nin : patientIdentifier",
                    displayName: $translate.instant('T.MEEDY.MODULE.PERSONAL_DATA.IDENTIFIER'),
                },
                {
                    field: "(type=='" + Enum.MEEDY.TERM_TYPE.CLAIM + "') ? claimDetails.phoneNumber : patientPhone",
                    displayName: "T.MEEDY.DATA.PHONE",
                },
                {
                    field: "resource.name",
                    displayName: $translate.instant('T.MEEDY.MODULE.PATIENT.CABINET'),
                },
                {
                    field: "begin | date:'dd.MM.yyyy HH:mm'",
                    displayName: $translate.instant('T.MEEDY.MODULE.PATIENT.VISIT_DATE_AND_HOUR'),
                },
                {
                    field: "offersNames",
                    displayName: $translate.instant('T.MEEDY.MODULE.PATIENT.SERVICE'),
                },
                {
                    field: "verifyCode",
                    displayName: "T.MEEDY.DATA.VERIFY_CODE",
                    cellTemplate: 'meedy/application/view/app/patient/grid-templates/verify-action-row.html',
                },
                {
                    field: "getPrice()",
                    displayName: "T.MEEDY.MODULE.PATIENT.PRICE_PLN"
                },
                {
                    field: "getPaymentMethodTranslateKey() | translate",
                    displayName: "T.MEEDY.MODULE.PATIENT.PAYMENT_TYPE"
                },
                {
                    field: "actions",
                    displayName: "T.MEEDY.MODULE.PATIENT.ACTIONS",
                    cellTemplate: 'meedy/application/view/app/patient/grid-templates/actions-row.html',
                }
            ];


            if (isMdxAuthenticated()) {
                $scope.columns.push({
                        field: "filesAction",
                        displayName: "T.MEEDY.MODULE.PATIENT.FILES",
                        cellTemplate: 'meedy/application/view/app/patient/grid-templates/files-action-row.html',
                    }
                );
            }
        }

        function setPermissions() {
        }

        function setListeners() {
            listeners.getDataPage = function (dataPage) {
                if (!dataPage) {
                    return;
                }
                $scope.patients = dataPage.data;
                $scope.patients = $scope.patients.map(function (patient) {
                    if (!patient.verifyCode) {
                        patient.verifyFunction = $scope.deletePatient;
                    }
                    return patient;
                });

                $scope.numberOfPages = (!dataPage.numberOfPages) ? 1 : dataPage.numberOfPages;
                if (isMdxAuthenticated() && dataPage.data.length > 0) {
                    getOrderDetailsForTerms(dataPage.data);
                }

            };

            function getOrderDetailsForTerms(terms) {
                var icrIds = [];

                _.forEach(terms, function (term) {
                    if (term.type == Enum.MEEDY.TERM_TYPE.CLAIM) {
                        icrIds.push(term.idIcrOrder);
                    }
                });

                mdxOrderModel.getOrderDetailsForTerms(icrIds)
                    .then(function (data) {
                        _.forEach($scope.patients, function (term) {
                            updatePatientWithClaimDetails(term, data);
                        });
                    });
            }

            function updatePatientWithClaimDetails(term, claimDetails) {

                if (term.type == Enum.MEEDY.TERM_TYPE.CLAIM && claimDetails[term.idIcrOrder]) {
                    var patient = claimDetails[term.idIcrOrder].product.claim.patientData;
                    term.claimDetails = {
                        fullName: patient.firstName + ' ' + patient.lastName,
                        nin: patient.nin,
                        phoneNumber: patient.phoneNumber,
                        status: (claimDetails[term.idIcrOrder]['mdxStatus']) ? claimDetails[term.idIcrOrder]['mdxStatus']['com.es.mdx.model.type.OrderStatusReasonType'] : null
                    };
                }

            }
	
			$rootScope.$on(Event.MEEDY.AUTH_INTERCEPTOR.MDX.READY, function (event, token) {
				setData();
				patientModel.getDataPage($scope.criteria).then(listeners.getDataPage);
			});

        }

        function setActions() {
            
            $scope.criteriaChanged = function () {
                patientModel.getDataPage($scope.criteria).then(listeners.getDataPage);
            };

            $scope.deletePatient = function (patient) {
                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/settings/availability/popup/availability-collisions-popup.html',
                    controller: 'meedy.popupAvailabilityCollisionsController',
                    resolve: {
                        terms: function () {
                            return list;
                        },
                        message: function () {
                            return 'T.MEEDY.MODULE.AVAILABILITY.SAVE_VACATION_CONFIRMATION_MESSAGE';
                        }
                    }
                }).then(function () {
                    vacationModel.createUserVacation($scope.vacation);
                }, function (error) {

                })
            };

            $scope.actionHandler = function (actionWrapper) {
                if ($scope[actionWrapper.action]) {
                    (actionWrapper.data) ? $scope[actionWrapper.action](actionWrapper.data) : $scope[actionWrapper.action]();
                }
            };

            $scope.verifyVisitByCode = function (resource) {
                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/patient/popup/patient-verify-code.html',
                    controller: 'meedy.patientVerifyCodePopupController',
                    resolve: {
                        resource: function () {
                            return resource;
                        },
                        title: function () {
                            return 'T.MEEDY.MODULE.PATIENT.INPUT_VERIFY_CODE';
                        }
                    }
                }).then(function () {
                    patientModel.getDataPage($scope.criteria).then(listeners.getDataPage);
                }, function (error) {

                })
            };

            $scope.cancelPatientVisit = function (term) {
                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/patient/popup/patient-term-cancel-popup.html',
                    controller: 'meedy.patientTermCancelPopupController',
                    resolve: {
                        term: function () {
                            return term;
                        }
                    }
                }).then(function () {
                    patientModel.getDataPage($scope.criteria).then(listeners.getDataPage);
                }, function () {

                })
            };

            $scope.reassignPatientVisit = function (term) {
                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/patient/popup/patient-term-reassign-popup.html',
                    controller: 'meedy.patientTermReassignController',
                    resolve: {
                        term: function () {
                            return term;
                        }
                    }
                }).then(function () {
                    patientModel.getDataPage($scope.criteria).then(listeners.getDataPage);
                }, function () {

                })
            };

            $scope.openFilesList = function (term) {
                createFilesPopup(term.idIcrOrder, term)
                    .then(function () {

                    }, function (error) {

                    })
            };

            $scope.openFilesPopup = function (icrOrderId) {
                createFilesPopup(icrOrderId, null)
                    .then(function () {

                    }, function (error) {

                    })
            };

        }

        function createFilesPopup(icrOrderId, term) {
            return $mdDialog.show({
                templateUrl: 'meedy/application/view/app/patient/popup/patient-order-files-popup.html',
                controller: 'meedy.patientOrderFilesPopupController',
                resolve: {
                    icrOrderId: function () {
                        return icrOrderId;
                    },
                    term: function () {
                        return term;
                    },
                    title: function () {
                        return 'T.MEEDY.MODULE.ORDER_FILES_POPUP.TITLE';
                    }
                }
            });
        }

        function configureInterface() {

        }

        function initialize() {
            applicationModel.fillViewportMode = true;

            patientModel.getDataPage($scope.criteria).then(listeners.getDataPage);


        }

        function isMdxAuthenticated(){
            return authInterceptor.mdxAuthenticated.value;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
